import { AxiosResponse } from 'axios';
import ApiService, { ApiArguments } from '@/api/api_service';
import { GetExecutionDaySetting200Response, ExecutionDaySettingApi, ExecutionDaySetting } from '@/api/openapi';

export class ExecutionDaySettingApiService extends ApiService {
  api = new ExecutionDaySettingApi(undefined, this.baseUrl, this.httpInstance);

  constructor() {
    super(true);
  }

  async getExecutionDaySetting(
    {
      options,
      errorHandlers,
    }: ApiArguments<{ executionDaySetting?: ExecutionDaySetting }> = {},
  ) {
    return this.checkResponse<GetExecutionDaySetting200Response>(
      this.api.getExecutionDaySetting(options),
      errorHandlers,
    );
  }

  async patchExecutionDaySetting({
    request,
    options,
    errorHandlers,
  }: ApiArguments<{ executionDaySetting?: ExecutionDaySetting }>): Promise<AxiosResponse<void>> {
    return this.checkResponse<void>(
      this.api.patchExecutionDaySetting({ executionDaySetting: request?.executionDaySetting }, options),
      errorHandlers,
    );
  }
}
